<template>
  <tr>
    <td data-label="Code">
      <strong>{{ referralCode.code }}</strong>
    </td>
    <td data-label="Discount">
      {{ referralCode.discount }}
    </td>
    <td data-label="commissionPercentage">
      {{ referralCode.commissionPercentage }}
    </td>
    <td data-label="amountAccrued">
      {{ referralCode.amountAccrued }}
    </td>
    <td data-label="Max usage">
        {{ referralCode.maxUse || 'N/A' }}
    </td>
    <td data-label="Usage">
        {{ referralCode.usage }}
    </td>
    <td data-label="Name">
        {{ referralCode.Account.username }}
    </td>
    <td data-label="Expiry">
        {{ referralCode.expiresAt | date_time_format }}
    </td>
    <div v-if="$user.administrator || $user.staff">
      <td class="button-3 text-center">
        <button class="my-2 btn btn-warning" @click="editReferralCode()">
          <i class="fa fa-edit" /> Edit
        </button>
        <button class="my-2 btn btn-danger" @click="deleteReferralCode()">
          <i class="fa fa-trash" /> Delete
        </button>
     </td>
    </div>
    
  </tr>
</template>

<script>
export default {
  name: 'ReferralCodeRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    referralCode () {
      return {
        Account: {},
        ...this.object
      }
    }
  },
  methods: {
    editReferralCode () {
      this.$emit('edit', { permalink: 'editReferralCode', uuid: this.referralCode.uuid })
    },
    deleteReferralCode () {
      this.$emit('deleteObject', { permalink: 'deleteReferralCode', uuid: this.referralCode.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/ReferralCodeRow.vue